import { render, staticRenderFns } from "./AppointmentPage.vue?vue&type=template&id=2e471ae5&scoped=true"
import script from "./AppointmentPage.vue?vue&type=script&lang=js"
export * from "./AppointmentPage.vue?vue&type=script&lang=js"
import style0 from "./AppointmentPage.vue?vue&type=style&index=0&id=2e471ae5&prod&lang=scss&scoped=true"
import style1 from "./AppointmentPage.vue?vue&type=style&index=1&id=2e471ae5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e471ae5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VIcon,VRow})
